import React from "react";
import { useTranslation } from "react-i18next";
import "./AboutFinalCTA.css";

/**
 * UniTech Engineering — À propos / 07 Conversion finale
 * Nouveau composant autonome. Aucun composant existant n'est modifié.
 * Les textes FR/EN suivent le sélecteur i18next du site.
 */
const CONTENT = {
  fr: {
    eyebrow: "ÉCHANGEONS SUR VOTRE PROJET",
    titleFirst: "Des ascenseurs plus connectés commencent par",
    titleAccent: "une conversation.",
    introduction:
      "Vous recherchez une solution pour connecter ou moderniser des équipements ? Parlons de votre parc, de vos contraintes et de vos priorités.",
    proofFirst: "Une équipe d’ingénierie impliquée",
    proofSecond: "Deux solutions métiers",
    cardTitle: "Parlons de vos besoins.",
    cardDescription:
      "Nous étudierons ensemble les options pertinentes pour votre environnement.",
    primary: "Parler à un expert",
    secondary: "Demander une démonstration OPENlift",
  },
  en: {
    eyebrow: "LET’S DISCUSS YOUR PROJECT",
    titleFirst: "More connected elevators start with",
    titleAccent: "a conversation.",
    introduction:
      "Looking for a solution to connect or modernize your equipment? Let's discuss your fleet, your constraints and your priorities.",
    proofFirst: "An involved engineering team",
    proofSecond: "Two dedicated solutions",
    cardTitle: "Let's talk about your needs.",
    cardDescription:
      "Together, we'll explore options suited to your environment.",
    primary: "Talk to an expert",
    secondary: "Request an OPENlift demonstration",
  },
};

function ArrowIcon({ diagonal = false }) {
  return (
    <svg viewBox="0 0 24 24" width="19" height="19" fill="none" aria-hidden="true" focusable="false">
      {diagonal ? (
        <path d="M5 18 18 5M8.5 5H18v9.5" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
      ) : (
        <path d="M4.5 12h14.5m-6-6 6 6-6 6" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
      )}
    </svg>
  );
}

export default function AboutFinalCTA() {
  const { i18n } = useTranslation();
  const language = (i18n.resolvedLanguage || i18n.language || "fr")
    .toLowerCase()
    .split("-")[0];
  const copy = CONTENT[language] || CONTENT.fr;

  return (
    <section id="about-final-contact" className="about-final" aria-labelledby="about-final-title">
      <div className="about-final__container">
        <div className="about-final__copy">
          <p className="about-final__eyebrow">{copy.eyebrow}</p>
          <h2 id="about-final-title" className="about-final__title">
            {copy.titleFirst}{" "}
            <span className="about-final__titleAccent">{copy.titleAccent}</span>
          </h2>
          <p className="about-final__introduction">{copy.introduction}</p>
          <ul className="about-final__proofs" aria-label={language === "en" ? "Why contact UniTech" : "Pourquoi échanger avec UniTech"}>
            <li>{copy.proofFirst}</li>
            <li>{copy.proofSecond}</li>
          </ul>
        </div>

        <div className="about-final__panel">
          <h3 className="about-final__panelTitle">{copy.cardTitle}</h3>
          <p className="about-final__panelDescription">{copy.cardDescription}</p>
          <div className="about-final__actions">
            <a href="/contact" className="about-final__button about-final__button--primary">
              <span>{copy.primary}</span>
              <ArrowIcon diagonal />
            </a>
            <a href="/openlift#ol-conversion-form" className="about-final__button about-final__button--secondary">
              <span>{copy.secondary}</span>
              <ArrowIcon />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
